module.exports = __webpack_public_path__ + "img/knsu_gallery7.90d9c9e1.jpg";